enum FromIframe {
  PressEnter = 'pressEnter',
  IsComericaBin = 'isComericaBin',
}

enum ToIframe {
  FormSubmit = 'form_submit',
}

export { FromIframe, ToIframe };
